import { render, staticRenderFns } from "./Acceleration.vue?vue&type=template&id=460455ff&scoped=true"
import script from "./Acceleration.vue?vue&type=script&lang=js"
export * from "./Acceleration.vue?vue&type=script&lang=js"
import style0 from "./Acceleration.vue?vue&type=style&index=0&id=460455ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460455ff",
  null
  
)

export default component.exports